import React, { useState, useEffect, useContext } from 'react';
import { Host } from '../types/Host';
import { createHost, getHostById, updateHost } from '../services/hostService';
import { useNavigate, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { UserRoleContext } from '../context/UserRoleContext';
import { useToast } from '../context/ToastContext';
import { ROUTES } from '../constants/routes';


const HostForm: React.FC<{}> = () => {

  const isUpdateHost = location.pathname.includes(ROUTES.UPDATE_HOST);

  const { userRole, setUserRole } = useContext(UserRoleContext);

  const host_id = isUpdateHost ? userRole?.host_id ?? '' : '';

  const toast = useToast();


  const navigate = useNavigate();


  const [host, setHost] = useState<Host>({
    host_id: '',
    host_name: '',
    contact_name: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    contact_email: '',
    color1: '',
    color2: '',
    logo: '',
  });

  useEffect(() => {
    if (host_id && host_id != "") {
      const fetchHost = async () => {
        const fetchedHost = await getHostById(host_id);
        if (fetchedHost) {
          setHost(fetchedHost);
        }
      };
      fetchHost();
    }
  }, [host_id]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setHost((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
    if (host_id) {
      await updateHost(host_id, host);
      toast.addToast('Host updated');
      navigate(ROUTES.HOST_OVERVIEW);
    } else {
      const hosta = await createHost(host);
      if (hosta) {
        setUserRole(hosta.userRole);
        navigate(ROUTES.CREATE_EVENT);
      } else {
        toast.addToast("Error creating host", true);
      }
    }
    } catch (error) {
      toast.addToast("Error creating host", true)
    }
  };

  const onCancel = (e: React.FormEvent) => {
    e.preventDefault();

    if (host_id) {
      navigate(ROUTES.HOST_OVERVIEW);
    } else {
      navigate(ROUTES.HOST_ORG_OVERVIEW);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <h1>{host_id ? `Update ${host.host_name}` : 'Create a Host'}</h1>
      <div>
        <label>Host Name:</label>
        <input type="text" name="host_name" value={host.host_name} onChange={handleChange} required={true}
          minLength={3}
          maxLength={100} />
      </div>
      <div>
        <label>Contact Name (First Last):</label>
        <input type="text" name="contact_name" value={host.contact_name} onChange={handleChange} required={true}
          minLength={2}
          maxLength={100} />
      </div>
      <div>
        <label>Address 1:</label>
        <input type="text" name="address1" value={host.address1} onChange={handleChange} required={true}
          minLength={3}
          maxLength={100} />
      </div>

      <div>
        <label>Address 2:</label>
        <input type="text" name="address2" value={host.address2} onChange={handleChange}
          maxLength={100} />
      </div>
      <div>
        <label>City:</label>
        <input type="text" name="city" value={host.city} onChange={handleChange} required={true}
          minLength={1}
          maxLength={100} />
      </div>
      <div>
        <label>State:</label>
        <input type="text" name="state" value={host.state} onChange={handleChange} required={true}
          minLength={2}
          maxLength={50} />
      </div>
      <div>
        <label>ZIP:</label>
        <input type="text" name="zip" value={host.zip} onChange={handleChange} required={true}
          minLength={5}
          maxLength={10} />
      </div>
      <div>
        <label>Contact Email:</label>
        <input type="email" name="contact_email" value={host.contact_email} onChange={handleChange} required={true}
          minLength={5}
          maxLength={100} />
      </div>
      {/* <div>
        <label>Color 1: (#000000)</label>
        <input type="text" name="color1" value={host.color1 || ''} onChange={handleChange} />
      </div>
      <div>
        <label>Color 2: (#000000)</label>
        <input type="text" name="color2" value={host.color2 || ''} onChange={handleChange} />
      </div>
       <div>
        <label>Logo URL:</label>
        <input type="text" name="logo" value={host.logo || ''} onChange={handleChange} />
      </div> */}

      <div className='buttonsRow'>
        <div className='buttonsLeft'>
          <button type="button" className='cancelButton' onClick={onCancel}>Cancel</button> {/* Cancel button */}

        </div>
        <button type="submit">{host_id ? 'Update Host' : 'Create Host'}</button>

      </div>
    </form>
  );
};


export default HostForm;
